import { Injectable } from '@angular/core';
import { SelectInputsList } from '@portal/shared/helpers/src';
import { ISelectInput, SearchSelector } from '@portal/shared/ui/filter';
import sortBy from 'lodash-es/sortBy';
import { TransactionFilter } from '../../enums/transaction-filter.enum';

export const transactionFilterList = {
  [TransactionFilter.Channel]: $localize`Channel`,
  [TransactionFilter.Currency]: $localize`Currency`,
  [TransactionFilter.Product]: $localize`Product`,
  [TransactionFilter.TransactionType]: $localize`Transaction Type`,
  [TransactionFilter.TransactionState]: $localize`Transaction State`,
  [TransactionFilter.Wallet]: $localize`Wallet`,
  [TransactionFilter.StoredCredentialType]: $localize`Stored Credential Type`,
  [TransactionFilter.Processor]: $localize`Processor`,
  [TransactionFilter.DestinationProcessor]: $localize`Processor`,  // Map destinationProcessor to "Processor" display name
  [TransactionFilter.AccountType]: $localize`Account Type`,
  [TransactionFilter.TokenType]: $localize`Token Type`,
  [TransactionFilter.Amount]: $localize`Amount`,
  [TransactionFilter.ReuseTokenContext]: $localize`Reuse Token Context`,
  [TransactionFilter.Origin]: $localize`Origin`,
  [TransactionFilter.FundingSource]: $localize`Funding Source`,
  [TransactionFilter.MerchantId]: $localize`Merchant ID`,
  [TransactionFilter.Organisation]: $localize`Organisation ID`,
  [TransactionFilter.Organization]: $localize`Organization`,
  [TransactionFilter.TransactionDate]: $localize`Transaction Date`,
  [TransactionFilter.SettledTime]: $localize`Transaction Date`,
  [TransactionFilter.CutOffTime]: $localize`Transaction Date`,
  [TransactionFilter.CashbackAmount]: $localize`Cashback Amount`,
  [TransactionFilter.GratuityAmount]: $localize`Gratuity Amount`,
  [TransactionFilter.FallbackMode]: $localize`Fallback Mode`,
};

@Injectable()
export class TransactionFilterList extends SelectInputsList {
  keyValue = transactionFilterList;
  list: ISelectInput[] = sortBy(this.getSelectInputs(), ['text']);
}
